<template>
  <b-container fluid>
      <b-row>
        <b-col cols="8">
          <AddPlayer class="mt-2"/>
        </b-col>
        <b-col cols="4" class="text-right">
          <Control class="mt-2"/>
        </b-col>
      </b-row>
      <PlayerList class="mt-3"/>
  </b-container>
</template>

<script>
import AddPlayer from '@/components/Game/AddPlayer.vue'
import PlayerList from '@/components/Game/PlayerList.vue'  
import Control from '@/components/Game/Control.vue' 

export default {
  name: 'Game',
  components: {
    AddPlayer,
    PlayerList,
    Control
  },
  data () {
    return {
      form: {
       playername: '',
       selected: '',
       points: [],
      },
      editPlayer: 0,
      max: 10,
    }
  },
  created: function() {
      const loadedGames = JSON.parse(localStorage.getItem('saved_games'))
      if (loadedGames) {
        this.loadedGames = loadedGames   
      }

      this.$store.dispatch('loadCurrentGame')
  },
  computed: {
      options: function() {
          if (this.players.length == 0) {
            return {}
          } 
          return this.players.map(player => player.name)
      },
      kartengebername: function() {
          return this.players[0].name
      },
      players: function() {
          return this.$store.getters.players
      },
      gamestarted: function() {
          return this.$store.getters.gameStarted 
      }
  },
}
</script>